import { useQuery } from "@tanstack/react-query";
import { API_TAGS } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchTags = () => {
  return useQuery({
    queryKey: ["tags"],
    queryFn: () => fetcher(API_TAGS),
    select: (response) => response?.data ?? [],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
